import {
  Box,
  type BoxProps,
  forwardRef,
  useMultiStyleConfig,
} from '@chakra-ui/react-v2';

import {
  EmptyStylesContextProvider,
  type EmptyStyles,
} from './EmptyStylesContext';
import type { EmptySize } from './types';

export type EmptyProps = BoxProps & { size?: EmptySize };

/**
 * A multipart component for indicating a region has no content. Composes `Box`.
 */
export const Empty = forwardRef<EmptyProps, 'div'>(
  ({ size = 'md', children, ...restProps }, ref) => {
    const emptyStyles = useMultiStyleConfig('Empty', {
      size,
    }) as EmptyStyles;

    return (
      <Box ref={ref} __css={emptyStyles.container} {...restProps}>
        <EmptyStylesContextProvider value={emptyStyles}>
          {children}
        </EmptyStylesContextProvider>
      </Box>
    );
  },
);
Empty.displayName = 'Empty';
